import StandardLayout from '@/common/layouts/StandardLayout';
import { InputGroup, InputGroupText } from 'reactstrap';
import { ReactComponent as CalendarIcon } from '@/assets/icons/calendar.svg';
import TournamentOverviewStats from './components/TournamentOverviewStats';
import { useState } from 'react';
import { subDays, subHours, subMinutes, subYears } from 'date-fns';

const TournamentsOverviewPage = () => {
  const [fromDate, setFromDate] = useState<Date | null>(new Date());

  const handleFromDateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const [type, time] = e.target.value.split('-');

    if (type === 'min') {
      setFromDate(subMinutes(new Date(), parseInt(time)));
    } else if (type === 'hour') {
      setFromDate(subHours(new Date(), parseInt(time)));
    } else if (type === 'day') {
      setFromDate(subDays(new Date(), parseInt(time)));
    } else if (type === 'year') {
      setFromDate(subYears(new Date(), parseInt(time)));
    } else if (type === 'all') {
      setFromDate(null);
    }
  };

  return (
    <StandardLayout
      pageTitle="Tournaments Overview"
      headerButton={
        <div className="d-flex align-items-center justify-content-between">
          <InputGroup>
            <InputGroupText>
              <CalendarIcon />
            </InputGroupText>
            <select className="form-select" onChange={handleFromDateChange}>
              <option value="min-5">Last 5 minutes</option>
              <option value="min-10">Last 10 minutes</option>
              <option value="min-30">Last 30 minutes</option>
              <option value="hour-1">Last 1 hour</option>
              <option value="hour-2">Last 2 hours</option>
              <option value="hour-4">Last 4 hours</option>
              <option value="hour-8">Last 8 hours</option>
              <option value="hour-12">Last 12 hours</option>
              <option value="hour-24">Last 24 hours</option>
              <option value="hour-48">Last 48 hours</option>
              <option value="day-7">Last week</option>
              <option value="day-30">Last 30 days</option>
              <option value="year-10">All</option>
            </select>
          </InputGroup>
        </div>
      }
    >
      <TournamentOverviewStats fromDate={fromDate} toDate={fromDate ? new Date() : null} />
    </StandardLayout>
  );
};

export default TournamentsOverviewPage;
